import React from "react";
import MobileWrapper from '../../layouts/MobileWrapper';
import './style.css';
import { connect } from 'react-redux';
import {Card, WhiteSpace, TextareaItem, List, InputItem, ImagePicker} from 'antd-mobile';
import {Modal,
  Button,
  message,
  Input} from 'antd';
import applicationCenterService from '../../services/Employee/application-center-service';
import WorkReportTemplate from '../WorkReport/WorkReportTemplate';
import moment from "moment";
import dailyReportService from '../../services/WorkReport/daily-report-service';


class MobileMyWeeklyReportDetail extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      data: props.fatherProps.location.state,
      ableReply: this.props.user.currentUser.PermissionDict.mobile_my_daily_report.reply_value,
      certificatePreviewVisiable: false,
      certificatePreviewImage: "",
      summaryImagePreviewVisiable: false,
      summaryImagePreviewImage: "",
    }
  }

  componentWillMount() {
    this.getDetailData();
  }

  getDetailData(gets = {modelId: this.state.data.id}) {
    applicationCenterService.myDailyReportDetail(gets, res => {
      this.setState({
        weeklyReportTemplate: JSON.parse(res.data.work_report.table_content),
        real_name: res.data.employee.real_name,
        department_name: res.data.employee.department_name,
        position_name: res.data.employee.position_name,
        date_1:res.data.work_report.date_1,
        date_2:res.data.work_report.date_2,
        replies: res.data.replies,
        question: res.data.work_report.question,
        employee_name_1: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_1 ? res.data.work_report.best_employees.employee_name_1 : "",
        employee_name_2: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_2 ? res.data.work_report.best_employees.employee_name_2 : "",
        employee_name_3: res.data.work_report.best_employees && res.data.work_report.best_employees.employee_name_3 ? res.data.work_report.best_employees.employee_name_3 : "",
        images: res.data.work_report.images ? JSON.parse(res.data.work_report.images) : [],
        summary: res.data.work_report.summary,
        summary_images: res.data.work_report.summary_images ? JSON.parse(res.data.work_report.summary_images) : [],
      });
      if(res.data.work_report.template_name&&res.data.work_report.template_name=="周工作报告"){
				this.setState({
					isAddtion:true
				})
		}else{
			this.setState({
				isAddtion:false
			})
		}
    }, err => {

    })

  }

  previewCertificateImage = (index, fs) => {
    this.setState({
      certificatePreviewVisiable: true,
      certificatePreviewImage: fs[index].url
    })
  }

  toggleCertificatePreviewModal = () => this.setState({
    certificatePreviewVisiable: !this.state.certificatePreviewVisiable
  })

  previewSummaryImage = (index, fs) => {
    this.setState({
      summaryImagePreviewVisiable: true,
      summaryImagePreviewImage: fs[index].url
    })
  }

  toggleSummaryPreviewModal = () => this.setState({
    summaryImagePreviewVisiable: !this.state.summaryImagePreviewVisiable
  })

  setCurrentComment = event => {
		this.setState({currentComment: event.target.value});
	}

  replyDailyReport  = callback => {
		let posts = {
			report_id: this.state.data.id,
			content: this.state.currentComment
		}
		if (posts.content) {
			dailyReportService.replyDailyReport(posts, res => this.replyDailyReportCallback(res, callback));
		}else{
			Modal.confirm({
				title: '您没有填写回复内容，确定要以空内容来回复么？',
				okText: '确认',
				cancelText: '取消',
				onOk: () => dailyReportService.replyDailyReport(posts, res => this.replyDailyReportCallback(res, callback)),
				onCancel: () => {}
			});
		}
  }
  
  replyDailyReportCallback = (res, callback) => {
		if (res.data.Success) {
      message.success("回复报告成功", 4);
			this.getDetailData()
			if ("function" === typeof callback) {
				callback();
			}else{
				this.closeCurrentModal();
			}
		}else{
			message.success("回复报告失败 " + res.data.Errors[0], 4);
		}
	}

  render() {
    return <div>
      <WhiteSpace size="lg"/>
        <Card full>
      <Card.Header title={"周工作报告"} extra={<span>Weekly Work Report</span>}/>
    <Card.Body>
      <div>姓名: {this.state.real_name} </div>
      <div>部门: {this.state.department_name} </div>
      <div>职位: {this.state.position_name} </div>
      <div>日期: {this.state.date_1} - {this.state.date_2} </div>
      </Card.Body>
      </Card>
      <WorkReportTemplate currentData={this.state.weeklyReportTemplate}  openDetail={true}/>
      {this.state.isAddtion &&
    <div style={{border: "1px solid #CCCCCC", borderRadius: "3px"}}>
      <div className="weeklyReportImages">
        {((this.state.images && 0 !== this.state.images.length) || !this.state.openDetail) &&
        <div style={{padding: "15px", border: "1px solid #cccccc"}}>
          <ImagePicker
            files={this.state.images}
            selectable={false}
            onImageClick={this.previewCertificateImage}
          />
          <Modal visible={this.state.certificatePreviewVisiable}
            footer={null}
            onCancel={this.toggleCertificatePreviewModal}>
            <img alt="example" style={{ width: '100%' }} src={this.state.certificatePreviewImage} />
          </Modal>
        </div>}
      </div>

      <div>
      <div style={{backgroundColor: 'rgb(26, 26, 26)', minHeight: '40px',lineHeight: '40px', border: '1px solid rgb(204, 204, 204)', padding: '0px 35px'}}><span style={{color:"#ffffff",fontSize:"17px"}}>
        本周工作总结</span></div>
        <div style={{padding: "5px 15px",backgroundColor: "#F0F0F0",border: "1px solid #CCCCCC"}}>
          <TextareaItem  value={this.state.summary} style={{fontSize:"14px", opacity:"0.65",overflowY:"hidden",maxHeight:"9999px"}} autosize={{ minRows: 4, maxRows: 999 }}/>
          {((this.state.summary_images && 0 !== this.state.summary_images.length) || !this.state.openDetail) &&
            <div className="weeklyReportImages" >
            <ImagePicker
              files={this.state.summary_images}
              selectable={false}
              onImageClick={this.previewSummaryImage}
            />
            <Modal visible={this.state.summaryImagePreviewVisiable}
              footer={null}
              onCancel={this.toggleSummaryPreviewModal}>
              <img alt="example" style={{ width: '100%' }} src={this.state.summaryImagePreviewImage} />
            </Modal>
          </div>}
        </div>
      </div>

      <div>
        <div style={{backgroundColor:"#1a1a1a",minHeight:"40px",lineHeight:"40px", border:"1px solid #cccccc",padding: "0px 35px"}}><span style={{color:"#ffffff",fontSize:"17px"}}>
          本周最佳员工</span></div>
        <div style={{padding: "5px 15px",backgroundColor: "#F0F0F0",border: "1px solid #CCCCCC",}}>
          <List>
            <InputItem type="text" value={this.state.employee_name_1} style={{fontSize:"14px", opacity:"0.65"}}></InputItem>
          </List>
          <List>
            <InputItem type="text" value={this.state.employee_name_2} style={{fontSize:"14px", opacity:"0.65"}}></InputItem>
          </List>
          <List>
            <InputItem type="text" value={this.state.employee_name_3} style={{fontSize:"14px", opacity:"0.65"}}></InputItem>
          </List>
        </div>
      </div>

      <div>
        <div style={{backgroundColor:"#1a1a1a",minHeight:"40px",lineHeight:"40px", border:"1px solid #cccccc",padding: "0px 35px"}}><span style={{color:"#ffffff",fontSize:"17px"}}>
          问题反馈</span></div>
        <div style={{padding: "5px 15px",backgroundColor: "#F0F0F0",border: "1px solid #CCCCCC"}}>
          <TextareaItem autosize={{ minRows: 4, maxRows: 999 }} rows={3} value={this.state.question} style={{fontSize:"14px", opacity:"0.65"}}/>
        </div>
      </div>
    </div>}

    <div style={{textAlign:"left", lineHeight: "30px", margin: "15px 0px"}}>
      <p>报告回复列表 : </p>
        {this.state.replies && this.state.replies.map(reply => {
          return (<div key={reply.id}>
      <span style={{color: "blue"}}>{reply.real_name}</span>
        <span> ( </span>
        <span style={{color: "blue"}}>
        {reply.reply_time ? moment(reply.reply_time).format("YYYY-MM-DD HH:MM") : ""}
      </span>
        <span> ) </span>
        <span> 回复 : </span>
        <span>{reply.content}</span>
        </div>)
      })}
      { this.state.ableReply && 
        <div style={{margin:"15px 0px"}}>
        <div style={{textAlign:"left",marginBottom:"15px"}}>回复此报告 : </div>
        <Input.TextArea ref="reportReply" value={this.state.currentComment} placeholder="填写回复内容"
        onChange={this.setCurrentComment}></Input.TextArea>
        <Button type="primary" onClick={this.replyDailyReport.bind(this)}>
        <span>回复</span>
        </Button>
        </div>
      }
    </div>


    </div>

  }

}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileMyWeeklyReportDetail));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileMyWeeklyReportDetail.js